
export const LOCALE_TEXT = {
    //url

    // for filter panel
    page: 'עמוד',
    more: 'עוד',
    to: 'עד',
    of: 'מ',
    next: 'הבא',
    last: 'אחרון',
    first: 'ראשון',
    previous: 'הקודם',
    loadingOoo: 'טוען נתונים...',

    // for set filter
    selectAll: 'בחר הכל',
    searchOoo: 'מחפש...',
    blanks: 'החסר',

    // for number filter and text filter
    filterOoo: 'מסנן...',
    applyFilter: 'מנקה סינון...',

    // for number filter
    equals: 'שווה',
    notEqual: 'לא שווה',
    lessThan: 'נמוך מ',
    greaterThan: 'גבוה מ',
    lessThanOrEqual: "נמוך או שווה",
    greaterThanOrEqual: "גבוה או שווה",
    inRange: "טווח ערכים",
    // for text filter
    contains: 'מכיל',
    notContains: 'לא מכיל',
    startsWith: 'מתחיל ב',
    endsWith: 'נגמר ב',

    // the header of the default group column
    group: 'קבוצה',

    // tool panel
    columns: 'עמודות',
    rowGroupColumns: 'Pivot Cols',
    rowGroupColumnsEmptyMessage: 'drag cols to group',
    valueColumns: 'ערך העמודה',
    pivotMode: 'Pivot-Mode',
    groups: 'קבוצות',
    values: 'ערכים',
    pivots: 'Pivots',
    valueColumnsEmptyMessage: 'גרור עמודות לכאן',
    pivotColumnsEmptyMessage: 'la drag here to pivot',

    // other
    noRowsToShow: 'טוען נתונים...',

    // enterprise menu
    pinColumn: 'הצמד עמודה',
    valueAggregation: 'ערך צבור',
    autosizeThiscolumn: 'הפעל גודל אוטומטי בעמודה זו',
    autosizeAllColumns: 'הפעל גודל אוטומטי בכל העמודות',
    groupBy: 'קבץ לפי',
    ungroupBy: 'פתח קיבוץ',
    resetColumns: 'אפס הגדרות עמודות',
    expandAll: 'הרחב הכל',
    collapseAll: 'laClose-em-up',
    toolPanel: 'הצג סרגל עמודות',
    export: 'ייצא',
    csvExport: 'ייצא לsvc',
    excelExport: 'ייצא לאקסל',

    // enterprise menu pinning
    pinLeft: 'הצמד לשמאל',
    pinRight: 'הצמד ליימין',
    noPin: 'בטל הצמדה',

    // enterprise menu aggregation and status panel
    sum: 'סכום',
    min: 'מימימום',
    max: 'מקסימום',
    none: 'ללא',
    count: 'כמות',
    average: 'ממוצע',

    // standard menu
    copy: 'העתק',
    copyWithHeaders: 'העתק עם הכותרת',
    ctrlC: 'ctrl C',
    paste: 'הדבק',
    ctrlV: 'ctrl V'


}
